import React, { useEffect } from 'react';
import Navbar from "../Navbar/Nabvar";
import Footer from '../Footer/Footer';
import { Box, Typography, Container, Card, CardContent, CardHeader, Divider, Button, useMediaQuery, useTheme } from '@mui/material';
import QuoteBox from '../Quote/QuoteBox';

const Transformation = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const primaryBlue = '#1F1B9E';

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const cardStyle = {
        width: '100%',
        maxWidth: '1200px',
        mx: 'auto',
        mb: 4,
        '& .MuiCardHeader-root': {
            textAlign: 'center',
        },
        '& .MuiCardContent-root': {
            textAlign: 'center',
        }
    };

    // Custom styles for the wavy background
    const wavyBackgroundStyle = {
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
                linear-gradient(to bottom right, 
                    rgba(240, 245, 255, 0.9),
                    rgba(230, 240, 255, 0.9)
                )
            `,
            zIndex: 0
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Navbar />

            {/* Top section with wavy background */}
            <Box
                sx={{
                    position: 'relative',
                    py: { xs: 4, sm: 6, md: 8 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: { xs: '200px', sm: '250px', md: '300px' },
                    ...wavyBackgroundStyle
                }}
            >
                <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center', width: '100%', px: 2 }}>
                    <img
                        src="old/image-removebg-preview.png"
                        alt="Logo"
                        style={{
                            maxHeight: isMobile ? 300 : isTablet ? 500 : 700,
                            width: 'auto',
                            maxWidth: '100%',
                            display: 'block',
                            margin: '0 auto',
                            paddingTop: '40px',
                        }}
                    />

                    <Typography
                        variant="body1"
                        sx={{
                            color: primaryBlue,
                            maxWidth: '1300px',
                            mx: 'auto',
                            fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                            mb: 3
                        }}
                    >
                        Gestalten Sie die Zukunft Ihres Unternehmens! Unsere interaktive Plattform unterstützt Sie bei der gezielten Transformation Ihres Geschäftsmodells –
                        individuell konfigurierbar und praxisnah.
                        Finden Sie neue Wachstumschancen und machen Sie Ihr Business fit für morgen!

                        <Box component="br" sx={{ display: { xs: 'none', sm: 'block' } }} />
                        <Box component="br" sx={{ display: { xs: 'none', sm: 'block' } }} />

                        <a href="https://xxx.bm-maps.com/" target="_blank" rel="noopener noreferrer" style={{ color: primaryBlue, textDecoration: 'underline', fontWeight: 'bold' }}>
                            Hier geht es direkt zum Konfigurator – starten Sie jetzt Ihre Transformation!
                        </a>
                    </Typography>
                </Box>
            </Box>

            {/* Hiking image section - responsive height */}
            {/*<Box*/}
            {/*    sx={{*/}
            {/*        width: '100%',*/}
            {/*        height: { xs: '300px', sm: '500px', md: '800px' },*/}
            {/*        backgroundImage: 'url("/old/wandern_kontakt.png")',*/}
            {/*        backgroundSize: 'cover',*/}
            {/*        backgroundPosition: 'center',*/}
            {/*    }}*/}
            {/*/>*/}

            {/* Contact Information Section */}
            <Box
                sx={{
                    position: 'relative',
                    py: { xs: 4, sm: 6, md: 8 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: { xs: '200px', sm: '250px', md: '300px' },
                    backgroundColor: 'white',
                    px: 2
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        color: primaryBlue,
                        mb: { xs: 2, sm: 3, md: 4 },
                        fontSize: { xs: '2rem', sm: '2.8rem', md: '3.5rem' },
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}
                >
                    Geschäftsmodell-Transformation
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: primaryBlue,
                        maxWidth: '1200px',
                        mx: 'auto',
                        fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                        textAlign: 'center',
                        mb: 3
                    }}
                >
                    BM-TRANSFORM ist ein smarter Online-Konfigurator, der Ihnen hilft, Ihr bestehendes
                    Geschäftsmodell einfach zu finden und ein neues Geschäftsmodell zu suchen.
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: primaryBlue,
                        maxWidth: '1300px',
                        mx: 'auto',
                        fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                        textAlign: 'center'
                    }}
                >
                    Sie erhalten automatisch Ihre individuelle Geschäftsmodell-Analyse als Download.
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', my: { xs: 2, sm: 3, md: 4 }, width: '100%', px: 2 }}>
                    <img
                        src="old/wo_starte_ich_2.jpg"
                        alt="Wo starte ich?"
                        style={{ maxWidth: '80%', height: 'auto' }}
                    />
                </Box>

                <Typography
                    variant="body1"
                    sx={{
                        color: primaryBlue,
                        maxWidth: '1300px',
                        mx: 'auto',
                        fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                        textAlign: 'center',
                        mb: 3
                    }}
                >
                    „Ein Geschäftsmodell-Muster ist eine bestimmte Konfiguration der Kernelemente eines Geschäftsmodells, deren Einsatz sich in mehreren Unternehmen als erfolgreich erwiesen hat."
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: primaryBlue,
                        maxWidth: '1300px',
                        mx: 'auto',
                        fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                        textAlign: 'center',
                    }}
                >
                    Oliver Gassmann, St. Gallen
                </Typography>

                <Divider
                    sx={{
                        width: { xs: "90%", sm: "80%", md: "70%" },
                        borderBottomWidth: "2px",
                        borderColor: primaryBlue,
                        margin: "16px auto",
                        my: { xs: 3, sm: 4, md: 5 }
                    }}
                />

                <Typography
                    variant="body1"
                    sx={{
                        color: primaryBlue,
                        maxWidth: '1300px',
                        mx: 'auto',
                        fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                        textAlign: 'center',
                        mb: 3
                    }}
                >
                    „Technologien, Trends und Kund*innen verändern Märkte radikal. Es besteht zunehmend die Notwendigkeit Unternehmen grundlegend zu verändern und Geschäftsmodelle zu transformieren."
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: primaryBlue,
                        maxWidth: '1300px',
                        mx: 'auto',
                        fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                        textAlign: 'center',
                    }}
                >
                    Dirk Lüttgens, RWTH Aachen
                </Typography>

                <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: { xs: 2, sm: 3, md: 4 }, flexDirection: { xs: 'column', md: 'row' }, gap: 4, alignItems: 'center' }}>
                        <Box sx={{ width: { xs: '100%', md: '50%' }, display: 'flex', justifyContent: 'center' }}>
                            <img
                                src="imac-links.png"
                                alt="imac_links"
                                style={{ maxWidth: '100%', height: 'auto' }}
                            />
                        </Box>
                        <Box sx={{ width: { xs: '100%', md: '50%' }, display: 'flex', justifyContent: 'center' }}>
                            <img
                                src="imac-rechts.png"
                                alt="imac_rechts"
                                style={{ maxWidth: '100%', height: 'auto' }}
                            />
                        </Box>
                    </Box>
                </Container>

                <Button
                    variant="outlined"
                    sx={{
                        mt: { xs: 2, sm: 3, md: 4 },
                        color: primaryBlue,
                        borderColor: primaryBlue,
                        borderRadius: '24px',
                        padding: { xs: '6px 24px', sm: '8px 32px' },
                        fontSize: { xs: '1rem', sm: '1.1rem' },
                        '&:hover': {
                            borderColor: primaryBlue,
                            backgroundColor: 'rgba(31, 27, 158, 0.04)'
                        },
                        mb: { xs: 5, sm: 8, md: 10 }
                    }}
                    onClick={() => window.open("https://xxx.bm-maps.com/", "_blank")}
                >
                    Geschäftsmodell<br />
                    transformieren
                </Button>
            </Box>

            <QuoteBox
                text="„Nichts ist so beständig wie der Wandel.“"
                maxWidth="1200px"
                hasOverlay={true}
                author="Heraklit"
            />

            <Footer />
        </Box>
    );
};

export default Transformation;